import styled from 'styled-components';

const Wrapper = styled.div`
  .component_line_canvas {
    height: ${(props) => {
      return props.canvasHeight ? `${props.canvasHeight}px` : '320px';
    }};
    width: 100%;
    /* margin-top: -30px; */
    svg:not(:root) {
      overflow: visible;
    }
  }
`;

export default Wrapper;
